import { render, staticRenderFns } from "./pc-Mains.vue?vue&type=template&id=987f9470&scoped=true&"
import script from "./pc-Mains.vue?vue&type=script&lang=js&"
export * from "./pc-Mains.vue?vue&type=script&lang=js&"
import style0 from "./pc-Mains.vue?vue&type=style&index=0&id=987f9470&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987f9470",
  null
  
)

export default component.exports